import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.defaults.plugins.legend.position = 'bottom';
ChartJS.defaults.plugins.legend.align = 'start';

const TotalLockers = ({ available, hold, occupied }: any) => {

    const data = {
        labels: ['Available locker', 'Occupied locker', 'Blocked locker'],
        datasets: [
            {
                label: '# of Votes',
                data: [available, occupied, hold],
                backgroundColor: [
                    'rgba(111, 207, 151,0.9)',
                    'rgba(255, 166, 41, 0.9)',
                    'rgba(151, 71, 255, 0.9)',
                ],
                borderColor: [
                    'rgba(111, 207, 151,1)',
                    'rgba(255, 166, 41, 1)',
                    'rgba(151, 71, 255, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    return <Doughnut data={data} />;
}



export { TotalLockers };